import { parsePhoneNumberFromString } from "libphonenumber-js";

// Normalizes a national number + selected calling code (e.g. "+44") into E.164.
// Using defaultCallingCode lets libphonenumber strip national trunk prefixes
// (e.g. UK leading "0") and reject malformed entries like a number typed under
// the wrong country code.
export const formatE164 = (countryCode, national) => {
  const callingCode = String(countryCode || "").replace(/[^0-9]/g, "");
  const digits = String(national || "").replace(/[^0-9]/g, "");

  if (!callingCode || !digits) {
    return { e164: "", isValid: false };
  }

  try {
    const parsed = parsePhoneNumberFromString(digits, {
      defaultCallingCode: callingCode,
    });
    if (parsed && parsed.isValid()) {
      return { e164: parsed.number, isValid: true };
    }
  } catch (error) {
    // fall through to invalid result
  }

  return { e164: "", isValid: false };
};
